import React from 'react';
import { components } from 'react-select';
import { Spacer, Text } from '@Sage/hoi-poi-ui';
import LabelPopover from 'components/LabelPopover';

export const createSingleValueComponent = (getExtraClassNameValue, popoverConfig) => {
    const hasPopover = popoverConfig?.parseDataForPopover && popoverConfig.type;

    return (singleValueProps) => {
        const { data } = singleValueProps;
        const extraClassName = getExtraClassNameValue ? getExtraClassNameValue(data) : '';
        const id = data?.value ?? data?.id;

        const valueAvatar =
            popoverConfig?.getImageForValue?.(id) ??
            (popoverConfig?.getImage ? popoverConfig.getImage(id) : null);

        const labelNode = (
            <Text type="body" isTruncated useTooltip className={extraClassName}>
                {data.label}
            </Text>
        );

        const content = valueAvatar ? (
            <div className="fm-select-row--flex">
                <div className="fm-select-row__icon">{valueAvatar}</div>
                <Spacer x={1} />
                <div className="fm-select-row__content">{labelNode}</div>
            </div>
        ) : (
            <span className={extraClassName}>{data.label}</span>
        );

        if (!hasPopover || id == null) {
            return <components.SingleValue {...singleValueProps}>{content}</components.SingleValue>;
        }

        const image = popoverConfig.getImage ? popoverConfig.getImage(id) : popoverConfig.image;

        return (
            <components.SingleValue {...singleValueProps}>
                <LabelPopover
                    id={id}
                    type={popoverConfig.type}
                    data={popoverConfig.remotePopover ? undefined : data}
                    remotePopover={popoverConfig.remotePopover}
                    parseDataForPopover={popoverConfig.parseDataForPopover}
                    image={image}
                >
                    {content}
                </LabelPopover>
            </components.SingleValue>
        );
    };
};

export const createMultiValueLabelComponent = (popoverConfig) => {
    const hasPopover = popoverConfig?.parseDataForPopover && popoverConfig.type;

    return (multiValueLabelProps) => {
        const { data } = multiValueLabelProps;
        const id = data?.value ?? data?.id;

        const valueAvatar =
            hasPopover &&
            (popoverConfig?.getImageForValue?.(id) ??
                (popoverConfig?.getImage ? popoverConfig.getImage(id) : null));

        const labelContent = valueAvatar ? (
            <div className="fm-select-row--flex">
                <div className="fm-select-row__icon">{valueAvatar}</div>
                <Spacer x={1} />
                <div className="fm-select-row__content">{data.label}</div>
            </div>
        ) : (
            data.label
        );

        if (!hasPopover || id == null) {
            return (
                <components.MultiValueLabel {...multiValueLabelProps}>
                    {labelContent}
                </components.MultiValueLabel>
            );
        }

        const image = popoverConfig.getImage ? popoverConfig.getImage(id) : popoverConfig.image;

        return (
            <components.MultiValueLabel {...multiValueLabelProps}>
                <LabelPopover
                    id={id}
                    type={popoverConfig.type}
                    data={popoverConfig.remotePopover ? undefined : data}
                    remotePopover={popoverConfig.remotePopover}
                    parseDataForPopover={popoverConfig.parseDataForPopover}
                    image={image}
                >
                    {labelContent}
                </LabelPopover>
            </components.MultiValueLabel>
        );
    };
};
